import React from "react";
import "../styleSheets/autoLogoutWarningBanner.css";
import { useTranslation } from "react-i18next";

type Props = {
  onStayLoggedIn: () => void;
  onWarningTimeLeft: number;
};

const AutoLogoutWarningBanner: React.FC<Props> = ({
  onStayLoggedIn,
  onWarningTimeLeft,
}) => {
  const { t } = useTranslation("common");
  return (
    <div className="logout-warning-banner">
      <p>
        ⚠️ {t("errorMessage.logoutWarning")}
        {onWarningTimeLeft}
        {t("errorMessage.logoutWarningSeconds")}
      </p>
      <button onClick={onStayLoggedIn}>
        {t("errorMessage.logoutWarningButton")}
      </button>
    </div>
  );
};

export default AutoLogoutWarningBanner;
